<template>
    <div>
        <b-btn v-b-toggle.collapse-1
               variant="primary-user"
               size="sm"
               class="text-left"
               :class="{'radius-bottom': open}"
               block>Review the shipping plan
        </b-btn>
        <b-collapse id="collapse-1">
            <div class="table-user border-accent">
                <div class="scroll-x">
                    <b-table hover
                            :class="['table-bordered']"
                            :busy="$store.state.loading"
                            :items="products"
                            :fields="getFields">

                        <template slot="empty" slot-scope="scope">
                            <h4>{{ scope.emptyText }}</h4>
                        </template>
                        <template slot="product.images" slot-scope="data">
                            <img v-if="data.item.product.images[0]"
                                :src="data.item.product.images[0] ? data.item.product.images[0].imageUrl : ''"
                                :alt="`image-${data.item.name}`"
                                width="50"
                                height="50">
                        </template>
                    </b-table>
                </div>
                <div class="text-right p-4">
                    <b-btn variant="primary-user"
                           size="sm"
                           :to="{name: 'ReplenishmentItem', params: {parent: 'plans', planId: this.$route.params.planId}}">Edit
                    </b-btn>
                </div>
            </div>
        </b-collapse>
    </div>
</template>

<script>
    import replenishmentItem from '@/assets/js/columns/replenishmentItem'
    import replenishmentPlanItem from '@/assets/js/columns/replenishmentPlanItem'

    export default {
        name: 'ReviewShippingPlan',
        data() {
            return {
                products: [],
                open: false
            }
        },
        computed: {
            getFields() {
                if (this.$route.params.parent === 'plans') {
                    return [...replenishmentItem, ...replenishmentPlanItem]
                } else return replenishmentItem
            }
        },
        created() {
            this.getPlanProducts()
        },
        mounted() {
            this.$root.$on('bv::collapse::state', (collapseId, isOpen) => {
                this.open = isOpen
            })
        },
        methods: {
            getPlanProducts() {
                this.$api('GET', this.$endpoints.incomesItems(this.$route.params.planId)).then(response => {
                    this.products = response
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/style/utils/_variables.scss";

    .collapse,
    .collapsing {
        padding-left: 0;
        padding-right: 0;
    }

    .radius-bottom {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }

    .table-user {
        overflow: inherit;
        padding-top: 0;

        .table {
            margin-bottom: 0;

            td,
            th {
                min-width: auto;
            }
        }
    }

    .border-accent {
        border: 1px solid $accent-color-user;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        overflow: hidden;
        margin-bottom: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Elements/ReviewShippingPlan.vue